import React, { useEffect, useRef, useState } from "react";
import Footer from "../LandingPage/Footer";
import {
  Box,
  Button,
  Card,
  Center,
  Grid,
  Skeleton,
  Tabs,
  Text,
} from "@mantine/core";
import { useStyles } from "./style";
import PricingCards from "./PricingCards";
import Faqcomp from "./Faq";
import StartedBanner from "../LandingPage/StartedBanner";
import Header from "../../components/Header/Header";
import { getPackages } from "../../services/package";
import { useLocation, useNavigate } from "react-router-dom";
import HeaderMain from "../../components/Header/HeaderMain";
import { useMediaQuery } from "@mantine/hooks";
import { pageInfoAnalytics, TrackPageExit } from "../../config/mixpanelConfig";

const PricingComp = () => {
  const { classes } = useStyles();
  const [packages, setPackages] = useState([]);
  const [loadingPackages, setLoadingPackages] = useState(true);
  const [showHeaderMain, setShowHeaderMain] = useState(true);
  const isMobileScreen = useMediaQuery("(max-width: 600px)");
  const isLaptopScreen = useMediaQuery("(max-width: 900px)");
  const navigate = useNavigate();
  const location = useLocation();
  const featuresRef = useRef(null);
  const [activeTab, setActiveTab] = useState("month");

  useEffect(() => {
    if (location.state?.scrollToFeatures && featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.state]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setShowHeaderMain(false);
      } else {
        setShowHeaderMain(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {}, []);

  const getAllPackages = async () => {
    const data = await getPackages();
    if (data) {
      setLoadingPackages(false);
      setPackages(data);
    }
  };

  useEffect(() => {
    getAllPackages();
    window.scrollTo(0, 0);
    pageInfoAnalytics("Pricing Page Viewed", "Pricing Page");
    TrackPageExit("Pricing");
  }, []);

  const handleClick = () => {
    navigate("/signup");
  };

  const renderSkeleton = () => {
    return (
      <Grid.Col span={isMobileScreen ? 12 : isLaptopScreen ? 6 : 3}>
        <Skeleton loading={true} mt={30}>
          <div style={{ height: "630px", width: "300px" }}></div>
        </Skeleton>
      </Grid.Col>
    );
  };

  const renderPackageCard = (item) => {
    return (
      <Grid.Col span={isMobileScreen ? 12 : isLaptopScreen ? 6 : 3}>
        <PricingCards
          item={item}
          onClick={handleClick}
          disabled={item?.duration === "year"}
          // isTrial={item?.name == "Free"}
          // isPriceCard={item?.name === "Silver"}
          // theme={item?.name === "Silver" && "black"}
        />
      </Grid.Col>
    );
  };

  const renderEnterpriseCard = () => {
    return (
      <Grid.Col span={12}>
        <Card shadow="sm" withBorder className={classes.enterpriseCard}>
          <Text className={classes.enterpriseCardHdng}>Enterprise</Text>
          <p className={classes.enterpriseCardTxt}>
            For larger companies with complex needs and controls.
            <br />
            Reach out to a sales representative
          </p>
          <Button
            className={classes.enterpriseCardHdngBtn}
            onClick={() => navigate("/contact-us")}
            disabled={activeTab === "year"}
          >
            Contact us
          </Button>
        </Card>
      </Grid.Col>
    );
  };

  return (
    <>
      <Box
        style={{
          opacity: showHeaderMain ? 1 : 0,
          visibility: showHeaderMain ? "visible" : "hidden",
          transition: "opacity 0.5s ease, visibility 0.5s ease",
        }}
      >
        <HeaderMain />
      </Box>
      <Box
        style={{
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 999,
          opacity: showHeaderMain ? 0 : 1,
          visibility: showHeaderMain ? "hidden" : "visible",
          transition: "opacity 0.5s ease, visibility 0.5s ease",
        }}
      >
        <Header />
      </Box>
      <Box className={classes.InlinePadding}>
        <Box className={classes.container}>
          <Text className={classes.primaryHeading}>
            Find the plan that <br /> works for you
          </Text>
          <Tabs
            variant="pills"
            className={classes.monthlyAndYearlyTab}
            value={activeTab}
            onTabChange={(value) => setActiveTab(value)}
          >
            <Tabs.List>
              <Tabs.Tab value="month">Monthly</Tabs.Tab>
              <Tabs.Tab value="year">Yearly</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value={activeTab}>
              {activeTab === "year" && (
                <Center>
                  <Text className={classes.comingSoonText}>
                    Yearly Package Coming Soon
                  </Text>
                </Center>
              )}
              <Grid gutter={14}>
                {loadingPackages
                  ? [1, 2, 3]?.map(() => renderSkeleton())
                  : packages?.packages
                      ?.filter(
                        ({ type, duration }) =>
                          type !== "skypoint" && duration === activeTab
                      )
                      ?.sort((a, b) => Number(a.level) - Number(b.level))
                      ?.map((item) => renderPackageCard(item))}
                {loadingPackages ? renderSkeleton() : renderEnterpriseCard()}
              </Grid>
            </Tabs.Panel>
          </Tabs>
          <Box>
            <Faqcomp />
          </Box>
        </Box>
      </Box>
      <StartedBanner />
      <Footer />
    </>
  );
};

export default PricingComp;
